import { IMRBaseComponent } from "../base"
import { IMRImageController } from "./image.controller"
import { $TIMEOUT_SERVICE_NAME, $ELEMENT_SERVICE_NAME } from "../../../services/system"

//#region Asset Imports

import './image.scss'
import * as TEMPLATE from './image.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrImage'
export const FILE_NAME_PREFIX: string = 'image'

export class IMRImageComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: IMRImageController,
            services: [$ELEMENT_SERVICE_NAME, $TIMEOUT_SERVICE_NAME],
            template: TEMPLATE
        })
    }

}